/* unplugin-vue-components disabled */import script from "./SaveVariety.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveVariety.vue?vue&type=script&setup=true&lang=js"

import "./SaveVariety.vue?vue&type=style&index=0&id=0981ee11&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0981ee11"]])

export default __exports__